namespace TabAurous.Finance {
    @Serenity.Decorators.registerEditor()
    export class PDCEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("Cleared", "Cleared");
            this.addOption("Bounced", "Bounced");

        }
    }
    @Serenity.Decorators.registerEditor()
    export class MyHardCodedEditor extends Serenity.Select2Editor<any, any> {
        constructor(hidden: JQuery) {
            super(hidden, null);
            this.addItem({ id: 'Calendar', text: 'Calendar' });
        }
    }
    @Serenity.Decorators.registerEditor()
    export class PDCTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(container: JQuery) {
            super(container, null);

            // add option accepts a key (id) value and display text value
            this.addOption("1", "Receivable");
            this.addOption("2", "Payable")

        }

    }
}
namespace TabAurous {

    @Serenity.Decorators.registerEditor()
    export class RMLookupEditor extends
        Serenity.LookupEditorBase<Serenity.LookupEditorOptions, any> {

        public myId: number;

        constructor(container: JQuery, opt: Serenity.LookupEditorOptions) {
            super(container, opt);
        }

        protected getLookupKey() {
            return this.buildLookupKey(this.myId);
        }

        protected getItems(lookup: Q.Lookup<any>) {
            var customLookup = Q.getLookup(this.buildLookupKey(this.myId));

            let items: any = super.getItems(customLookup);

            // this is demo about filtering lookup items

            // only take item that has Id % 5 = 0 (5, 10, 15, 20...)
            items = items.filter(x => Q.toId(x.Id) % 5 == 0); // here 'Id' field is hardcode for demo

            // just take maximum first 5 items
            if (items.length >= 5) {
                return items.slice(0, 5);
            }
            else {
                return items;
            }
        }

        private buildLookupKey(id?: number): string {

            //demo switch lookup key by id

            if (id == 104) {
                return "Metal";
            } else {
                if (id == 105) {
                    return "Stone";
                }
                else {
                    return "RM"; // default
                }
            }
        }
    }
}